import Vue from 'vue'

import Header from './components/header.vue'
const header = () => new Vue(Header)

import People from './components/people.vue'
const people = () => new Vue(People)


export { header, people }
